import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonCtaText } from 'src/modules/utils/constants'
export default (props) => (
  <USTemplateDefault
    noIndex={true}
    location={props.location}
    lang="en"
    market="us"
    title="Stream Live TV & Sports"
    subtitle={
      <>
        Enjoy a special offer through BenefitHub.
        <br />
        Save $25/mo off your first two months.
      </>
    }
    offerCode={promoCodes.benefithub}
    ctaText={commonCtaText.startWatchingForFree}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-benefithub.png?w=451&ch=width&auto=format,compress"
  />
)
